"use client"

import { Phone, MessageCircle } from "lucide-react"
import "./FloatingContact.css"

const FloatingContact = () => {
  // Phone number and WhatsApp number (with country code)
  const phoneNumber = "+919350019570"
  const whatsappNumber = "919350019570"

  const handlePhoneClick = () => {
    window.location.href = `tel:${phoneNumber}`
  }

  const handleWhatsAppClick = () => {
    window.open(
      `https://wa.me/${whatsappNumber}?text=Hello%20imperia%20Auto,%20I'm%20interested%20in%20your%20products.`,
      "_blank",
    )
  }

  return (
    <div className="floating-contact">
      <button className="floating-btn phone-btn" onClick={handlePhoneClick} aria-label="Call us">
        <Phone size={20} />
        <span className="btn-tooltip">Call Us</span>
      </button>

      <button className="floating-btn whatsapp-btn" onClick={handleWhatsAppClick} aria-label="Chat on WhatsApp">
        <MessageCircle size={20} />
        <span className="btn-tooltip">WhatsApp</span>
      </button>
    </div>
  )
}

export default FloatingContact
